import { RouterContext } from '../../libs/gs-component-right-rail';
import React, { useContext } from 'react';

import { Maybe, useVisibilityMutation } from '../../generated/graphql';
import Honeybadger from 'honeybadger-js';
import SettingToggle from './SettingToggle/SettingToggle';

interface VisibilityProps {
  searchable?: Maybe<boolean>;
  isPublished?: boolean;
  onError: () => void;
}

export const Visibility: React.FC<VisibilityProps> = ({ searchable = false, isPublished = false, onError }) => {
  const [updateVisibility] = useVisibilityMutation();
  const { push } = useContext(RouterContext);

  const onChange = async (checked: boolean): Promise<void> => {
    if (checked === true) {
      try {
        await updateVisibility({
          variables: {
            attributes: {
              searchable: true,
            },
          },
        });
        push('visibilityOnConfirmation');
      } catch (error) {
        Honeybadger.notify(error, {
          message: 'Error toggling visibility',
          context: {
            error,
          },
        });
        onError();
      }
    } else {
      push('visibilityOffConfirmation');
    }
  };

  return (
    <SettingToggle
      title={'Appear in search engines (recommended)'}
      subtitle={searchable && isPublished ? 'Searchable outside The Knot.' : 'Searchable after you publish.'}
      checked={searchable || false}
      onChange={onChange}
      dataTestId="visibility_toggle"
    />
  );
};
